export default "__VITE_PUBLIC_ASSET__6a2fc15f__"